import {
    BloombergMarketDataRequest,
    requestUid,
} from 'marketData/MarketDataRequest';
import {
    ExternalMarketDataStrategy,
    NullExternalMarketDataStrategy,
    RefDataReceivedHandlerOptions,
} from 'marketData/ExternalMarketDataStrategy';
import {
    addBars,
    addTicks,
    BarData,
    setRefData,
    TickData,
} from 'marketData/store/marketDataSlice';
import { Store } from 'redux';

export class MarketDataService {
    private strategy: ExternalMarketDataStrategy =
        new NullExternalMarketDataStrategy();
    private requests: BloombergMarketDataRequest[] = [];

    public _store: Store | undefined;

    public subscribe(request: BloombergMarketDataRequest): void {
        this.strategy.subscribe(request);

        this.requests.push(request);
    }

    public unsubscribe(request: BloombergMarketDataRequest): void {
        this.strategy.unsubscribe(request);

        this.requests = this.requests.filter(
            (r) => requestUid(r) !== requestUid(request)
        );
    }

    public setStrategy(strategy: ExternalMarketDataStrategy) {
        this.strategy = strategy;

        for (const request of this.requests) {
            strategy.subscribe(request);
        }

        strategy.onMarketBarDataReceived(
            this.onMarketBarDataReceived.bind(this)
        );
        strategy.onMarketTickDataReceived(
            this.onMarketTickDataReceived.bind(this)
        );
        strategy.onRefDataReceived(this.onRefDataReceived.bind(this));
    }

    private onMarketBarDataReceived(data: BarData[]) {
        this.store.dispatch(addBars(data));
    }

    private onMarketTickDataReceived(data: TickData[]) {
        this.store.dispatch(addTicks(data));
    }

    private onRefDataReceived(options: RefDataReceivedHandlerOptions) {
        this.store.dispatch(setRefData(options));
    }

    private get store() {
        if (!this._store) {
            throw new Error('Store has not been set');
        }
        return this._store;
    }

    public setStore(next: Store) {
        this._store = next;
    }
}
